@file:OptIn(InternalResourceApi::class)

package tregz.robbins.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/tregz.robbins.generated.resources/"

@delegate:ResourceContentHash(-1_005_608_906)
public val Res.font.geist_bold: FontResource by lazy {
      FontResource("font:geist_bold", setOf(
        ResourceItem(setOf(), "${MD}font/geist_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_304_051_833)
public val Res.font.geist_light: FontResource by lazy {
      FontResource("font:geist_light", setOf(
        ResourceItem(setOf(), "${MD}font/geist_light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_126_547_789)
public val Res.font.geist_medium: FontResource by lazy {
      FontResource("font:geist_medium", setOf(
        ResourceItem(setOf(), "${MD}font/geist_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_951_477_210)
public val Res.font.geist_mono_medium: FontResource by lazy {
      FontResource("font:geist_mono_medium", setOf(
        ResourceItem(setOf(), "${MD}font/geist_mono_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(630_879_188)
public val Res.font.geist_mono_regular: FontResource by lazy {
      FontResource("font:geist_mono_regular", setOf(
        ResourceItem(setOf(), "${MD}font/geist_mono_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-179_680_350)
public val Res.font.geist_regular: FontResource by lazy {
      FontResource("font:geist_regular", setOf(
        ResourceItem(setOf(), "${MD}font/geist_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(282_211_162)
public val Res.font.geist_semibold: FontResource by lazy {
      FontResource("font:geist_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/geist_semibold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(826_869_539)
public val Res.font.instrument_serif_italic: FontResource by lazy {
      FontResource("font:instrument_serif_italic", setOf(
        ResourceItem(setOf(), "${MD}font/instrument_serif_italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(79_265_682)
public val Res.font.instrument_serif_regular: FontResource by lazy {
      FontResource("font:instrument_serif_regular", setOf(
        ResourceItem(setOf(), "${MD}font/instrument_serif_regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("geist_bold", Res.font.geist_bold)
  map.put("geist_light", Res.font.geist_light)
  map.put("geist_medium", Res.font.geist_medium)
  map.put("geist_mono_medium", Res.font.geist_mono_medium)
  map.put("geist_mono_regular", Res.font.geist_mono_regular)
  map.put("geist_regular", Res.font.geist_regular)
  map.put("geist_semibold", Res.font.geist_semibold)
  map.put("instrument_serif_italic", Res.font.instrument_serif_italic)
  map.put("instrument_serif_regular", Res.font.instrument_serif_regular)
}
